import { convertToTitleCase } from '@/services/utils/global'

export const auditUserLabel = (id, name) => {
  if (! id) return '—'
  if (! name) return `Unknown user #${id}`
  return name
}

export const auditTypeLabel = (value) => {
  if (! value) return '—'
  return convertToTitleCase(value)
}

export const auditRecordTitle = (record) => {
  if (record.title) return record.title
  return auditTypeLabel(record.txn_type)
}

export const auditStatusTone = (status) => {
  const tones = {
    approved: 'is-success',
    rejected: 'is-danger',
    cancelled: 'is-danger',
    pending: 'is-warning',
    pending_approval: 'is-warning'
  }
  return tones[status] || 'is-muted'
}
